import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCurrentFormattedDate, getTimeOfDay } from "../../utils";
import Heading from "./Heading";
import EmployeeOverview from "./EmployeeOverview";
import AttendanceRate from "./AttendanceRate";
import TotalEmployees from "./TotalEmployees";
import NdovuGraph from "./NdovuGraph";
import PersonnelFolderTable from "../personnel/PersonnelFolderTable";
import { fetchPersonnelSummary } from "../../features/dropdown/dropdownSlice";
import CardLoading from "../../components/CardLoading";

function DashboardMain() {
  const { user } = useSelector((state) => state.auth);
  const { personnelSummary,loading } = useSelector((state) => state.dropdown);
  const dispatch = useDispatch();

  async function fetchPersonnelSummaryData(){
    await dispatch(fetchPersonnelSummary())
  }

  useEffect(()=>{
    fetchPersonnelSummaryData()
  },[])  

  if (loading) return <CardLoading />;
  
  return (
    <div className="w-full h-full overflow-y-scroll lg:px-10 px-3 lg:py-5">
      <Heading />
      <div className="flex flex-wrap w-full gap-4 mt-5">
        <div className="service-card    w-full md:w-[calc(50%-0.5rem)] lg:w-[600px] p-5 cursor-pointer  ">
          <EmployeeOverview />
        </div>
        <div className="service-card w-full md:w-[calc(50%-0.5rem)] lg:w-[600px] p-5 cursor-pointer ">
          <TotalEmployees />
        </div>
      </div>

     <div className="mt-[1.25rem] w-full flex lg:flex-row flex-col lg:gap-y-0 gap-y-10 gap-x-5">
        <NdovuGraph />
        <AttendanceRate/>
      </div>
     
      <div className="bg-white rounded-[10px] lg:px-10 px-3 mt-[1.25rem] mb-[1.25rem]">
        <PersonnelFolderTable limit={5} />
      </div>
      
    </div>
  );
}

export default DashboardMain;
